// import React from "react";

// const HeroSection = () => {
//   return (
// <section className="relative w-full h-[700px] lg:h-[300px] overflow-hidden">      
//       {/* Desktop Image */}
//       <img
//         src="https://bakelore.com/images/bakelore-banner"
//         alt="hero"
//         className="hidden md:block absolute inset-0 w-full h-full object-cover"
//       />

//       {/* Mobile Image */}
//       <img
//         src="https://bakelore.com/images/mobile-landingpage-bg"
//         alt="hero"
//         className="block md:hidden absolute inset-0 w-full h-full object-cover"
//       />

//     </section>
//   );
// };

// export default HeroSection;

import React from "react";

const HeroSection = () => {
  return (
    <a
      href="#"
      target="_blank"
      rel="noopener noreferrer"
      className="block"
    >
      <section className="relative w-full h-[700px] lg:h-[300px] overflow-hidden cursor-pointer">
        
        {/* Desktop Image */}
        <img
          src="https://bakelore.com/images/bakelore-banner"
          alt="hero"
          className="hidden md:block absolute inset-0 w-full h-full object-cover"
        />

        {/* Mobile Image */}
        <img
          src="https://bakelore.com/images/mobile-landingpage-bg"
          alt="hero"
          className="block md:hidden absolute inset-0 w-full h-full object-cover"
        />

      </section>
    </a>
  );
};

export default HeroSection;